import React from "react";

export const SectionHeading = ({ kicker, title, className = "" }) => (
  <div className={`mb-12 ${className}`}>
    {kicker && (
      <div className="flex items-center gap-3 mb-3">
        <span className="w-8 h-[2px] bg-brand" />
        <span className="font-mono text-xs uppercase tracking-[0.3em] text-brand">{kicker}</span>
      </div>
    )}
    <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl uppercase tracking-tight leading-none">{title}</h2>
  </div>
);

export const Loader = () => (
  <div className="min-h-[50vh] flex items-center justify-center">
    <div className="font-display text-3xl text-brand animate-pulse tracking-widest">LOADING...</div>
  </div>
);

export const PageHero = ({ title, kicker, image }) => (
  <section className="relative pt-40 pb-20 px-6 md:px-12 lg:px-20 overflow-hidden">
    {image && (
      <div className="absolute inset-0 z-0">
        <img src={image} alt="" className="w-full h-full object-cover opacity-20 grayscale" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/60 via-[#050505]/80 to-[#050505]" />
      </div>
    )}
    <div className="relative z-10 spotlight">
      {kicker && <span className="font-mono text-xs uppercase tracking-[0.3em] text-brand">{kicker}</span>}
      <h1 className="font-display text-6xl sm:text-7xl lg:text-8xl uppercase tracking-tighter leading-none mt-3">{title}</h1>
    </div>
  </section>
);
